<div class="process-card">
  <div fxLayout="row" fxLayoutAlign="start center" class="process-card--header">
    <h2 fxLayout="row" fxLayoutAlign="start center">
      <div class="forge-typography--heading4" [textContent]="entity.Title"></div>
      <div class="forge-typography--subheading1 process-card--subtitle" [textContent]="entity.SubTitle"></div>
    </h2>
    @for (text of entity.SecondaryLabels; track text) {
      <div>
        <div class="forge-typography--subheading1 process-card--subtitle" [textContent]="text"></div>
      </div>
    }
  </div>
  <div fxLayout="row" fxLayoutAlign="space around" class="process-card--steps">
    @for (step of steps; track step) {
      <div class="processStep">
        <process-step [enableLink]="enableLink" [entity]="step" [isProcessing]="isProcessing"></process-step>
      </div>
    }
  </div>
</div>


<!-- <forge-card class="process-card no-padding">
<div attr.slot="header" fxLayout="row" fxLayoutAlign="start center" class="process-card--header">
  <div class="forge-typography--heading4" [textContent]="entity.Title"></div>
  <div fxLayout="row" fxLayoutAlign="start center">
    <div class="forge-typography--subheading1 process-card--subtitle" [textContent]="entity.SubTitle"></div>

    <div *ngFor="let text of entity.SecondaryLabels">
      <div class="forge-typography--subheading1 process-card--subtitle" [textContent]="text"></div>
    </div>
  </div>
</div>
<div fxLayout="row" fxLayoutAlign="space around" class="process-card--steps">
  <div class="processStep" *ngFor="let step of steps">
    <process-step [enableLink]="enableLink" [entity]="step" [isProcessing]="isProcessing"></process-step>
  </div>
</div>
</forge-card> -->

@if (isProcessing) {
  <busy-indicator page="true"></busy-indicator>
}
